import React, { ComponentProps } from 'react'

import { refreshData } from '@/entities/schedules/thunks/refreshData'
import { toggleLayoutLock } from '@/entities/widgetWindows'
import { Icon, IconButton, ToggleButton } from '@/shared/components'
import { ToggleButtonProps } from '@/shared/components/ToggleButton/ToggleButton'
import { useAppDispatch, useAppSelector } from '@/shared/store'
import { pxToRem } from '@/shared/styles/themes'
import { faLock, faUnlock } from '@fortawesome/pro-light-svg-icons'
import { faArrowsRotate } from '@fortawesome/pro-regular-svg-icons'
import { styled } from '@mui/material'

export type OperationsSecondaryControlsProps = ComponentProps<'div'> & {
  slotProps?: {
    toggleLockButton?: ToggleButtonProps
  }
}

export const OperationsSecondaryControls: React.FC<OperationsSecondaryControlsProps> = ({  slotProps, ...props }) => {
  const isLayoutLock = useAppSelector(state => state.widgetWindows.isLayoutLock)
  const dispatch = useAppDispatch()

  const onToggleLayoutLock = () => {
    dispatch(toggleLayoutLock())
  }

  const onRefreshData = () => {
    dispatch(refreshData({}))
  }

  return (
    <StyledOperationsSecondaryControls {...props}>
      <IconButton
        tooltipTitle="Refresh data"
        round={false}
        sx={{
          width: pxToRem(48),
          height: pxToRem(48),
          borderRadius: pxToRem(8),
          margin: 0,
        }}
        slotProps={{
          tooltip: {
            placement: 'bottom',
          },
        }}
        onClick={onRefreshData}
      >
        <Icon icon={faArrowsRotate} />
      </IconButton>
      <ToggleButton
        value="checked"
        secondary
        tooltipTitle="Lock window layout"
        text
        selected={isLayoutLock}
        onChange={onToggleLayoutLock}
        sx={{
          width: pxToRem(48),
          height: pxToRem(48),
          borderRadius: pxToRem(8),
          border: 'none',
        }}
        {...slotProps?.toggleLockButton}
      >
        <Icon icon={isLayoutLock ? faLock : faUnlock} />
      </ToggleButton>
    </StyledOperationsSecondaryControls>
  )
}

const StyledOperationsSecondaryControls = styled('div')`
  border-radius: ${pxToRem(8)};
  background-color: ${({ theme }) => theme.palette.custom.widgetToolbar.backgroundColor};
  box-shadow: ${({ theme }) => theme.palette.custom.widgetToolbar.boxShadow};
  min-height: ${props => props.theme.layout.widgetToolbarHeight};
  margin-right: ${props => props.theme.typography.pxToRem(8)};
  display: flex;
  align-items: center;
`
